import { Controller } from "stimulus";
import {getState, setState} from '../search_results/state'


export default class extends Controller {
  static values = {
    flagship: String
  }

  routePostMessage(e) {
    if (e.origin === this.flagshipValue) {
      let method = e.data.split(':')[0];
      switch (method) {
        case "setPrintTitle":
          $('#print_modal #print-modal-title').text(e.data.split(':')[1]);
          break;
        case "resetPrintButtons":
          this.resetPrintModal();
          break;
        case "addPrintButton":
          let data = e.data.split(':');
          let text = data[1];
          let id = data[2];
          let classname = data[3];
          let submit = "document.getElementById('print_iframe').contentWindow.postMessage('" + data[4] + "', '" + this.flagshipValue + "')";
          $('#print_modal #native_buttons').append('<button id="' + id + '" class="' + classname + '" onclick="' + submit + '">' + text + '</button>');
          break;
      }
    }
  }

  showPrint () {
    this.resetPrintModal();
    let modal = $('#flagship_print_modal_content');
    let iframe = document.createElement('iframe');
    iframe.id = "print_iframe";

    let from_mweb = "&from_mweb=true";
    let filter = "&_filter=" + getState('filter');
    let selected = $('.selectListingsControl:checked');
    let listings = selected.toArray().map((sel) => sel.id.split('_')[1]);
    let rs = "&selected=" + listings.join(",");
    let total = "&results_totallistings=" + getState('listingCountTotal');
    let cart_total = "&cart_totallistings=" + listings.length;
    let privacy = "&report_puborpriv=public";
    let view = "&view_id=" + $('.user-view-link.userViewLink.selected-view').data("view-id");

    iframe.src = this.flagshipValue + "/cgi-bin/mainmenu.cgi?cmd=srv+srch_rs/print.html" + from_mweb + filter + rs + total + cart_total + privacy + view;
    $(modal).empty();
    $(modal).append(iframe);
    $('#print_modal').modal('toggle');
  }

  resetPrintModal() {
    $('#print_modal #print-modal-title').text("");
    $('#print_modal #native_buttons').html("");
  }
}
